// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Team__Wrapper_24Ezk","Title":"Team__Title_23c0r"};